import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { FormGroup } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { FormsService } from '../forms.service';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-questions',
    templateUrl: './questions.component.html',
    styleUrls: ['./questions.component.scss'],
    standalone: false
})
export class QuestionsComponent implements OnInit, OnDestroy {
  fields: any = [];
  currentQuestion: any;
  currentIndex: any = 0;
  form: FormGroup = new FormGroup({});
  type: any;
  frequency: any;
  responseOptions: any;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private formsService: FormsService,
    public dialogRef: MatDialogRef<QuestionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data) {
      this.fields = data?.fields;
      this.form = data?.form;
      this.type = data?.type;
      this.frequency = data?.frequency;
      this.responseOptions = data?.responseOptions;
    }
  }

  ngOnInit() {
    this.form.markAsTouched();
    this.form.markAsPristine();

    this.getCurrentQuestion();

    this.formsService.triggerNext
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        this.onNextClick();
      });

    this.formsService.triggerBack
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        this.onPreviousClick();
      });
  }

  getCurrentQuestion() {
    this.currentQuestion = this.fields[this.currentIndex];
    return this.currentQuestion;
  }

  onNextClick() {
    this.currentIndex++;
    if (this.currentIndex > this.fields.length - 1) {
      this.currentIndex = 0;
    }
    this.getCurrentQuestion();
  }

  onPreviousClick() {
    this.currentIndex--;
    if (this.currentIndex < 0) {
      this.currentIndex = this.fields.length - 1;
    }
    this.getCurrentQuestion();
  }

  close() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
